// src/data/groupedGalleryImages.ts

export interface GalleryImage {
  src: string;
  caption?: string;
}

export interface ImageGroup {
  title: string;
  images: GalleryImage[];
}

export const GROUPED_GALLERY_IMAGES: ImageGroup[] = [
  {
    title: 'Western Meadows Community',
    images: [
      {
        src: '/images/community/Entrance 1.JPG',
        caption: 'Entrance 1',
      },
      {
        src: '/images/community/Entrance 2.JPG',
        caption: 'Entrance 2',
      },
      {
        src: '/images/community/Community 1.webp',
        caption: 'Community 1',
      },
      {
        src: '/images/community/Community 2.webp',
        caption: 'Community 2',
      },
      {
        src: '/images/community/Community 3.webp',
        caption: 'Community 3',
      },
      {
        src: '/images/community/community seating.webp',
        caption: 'Community Seating',
      },
      {
        src: '/images/community/Lotus Pond in Phase 2 Park 9.JPG',
        caption: 'Lotus Pond In Phase 2 Park 9',
      },
      {
        src: '/images/community/Park.JPG',
        caption: 'Park',
      },
      {
        src: '/images/community/Phase 1 Park 2 Gazebo.webp',
        caption: 'Phase 1 Park 2 Gazebo',
      },
      {
        src: '/images/community/Phase 1 Park 2 Outdoor Movie Screen.JPG',
        caption: 'Phase 1 Park 2 Outdoor Movie Screen',
      },
      {
        src: '/images/community/Phase 2 Park 7.JPG',
        caption: 'Phase 2 Park 7',
      },
      {
        src: '/images/community/Phase 3 - Park 12 Seating.JPG',
        caption: 'Phase 3   Park 12 Seating',
      },
      {
        src: '/images/community/Phase 3 Entrance.JPG',
        caption: 'Phase 3 Entrance',
      },
      {
        src: '/images/community/Phase 3 Median.JPG',
        caption: 'Phase 3 Median',
      },
      {
        src: '/images/community/Phase 3 Park 12 Gazebo.JPG',
        caption: 'Phase 3 Park 12 Gazebo',
      },
      {
        src: '/images/community/Phase 4 median 1.JPG',
        caption: 'Phase 4 Median 1',
      },
      {
        src: '/images/community/Phase 4 Median.JPG',
        caption: 'Phase 4 Median',
      },
      {
        src: '/images/community/Phase 4 Park 3.JPG',
        caption: 'Phase 4 Park 3',
      },
      {
        src: '/images/community/Phase 4 Park 4 Gazebo.JPG',
        caption: 'Phase 4 Park 4 Gazebo',
      },
      {
        src: '/images/community/Phase 4 Transformer.JPG',
        caption: 'Phase 4 Transformer',
      },
      {
        src: '/images/community/Phase 4.JPG',
        caption: 'Phase 4',
      },
    ],
  },
  {
    title: 'Community Center',
    images: [
      {
        src: '/images/community_center/CC_Front.jpg',
        caption: 'Community Center Front View',
      },
      {
        src: '/images/community_center/CC_East.jpg',
        caption: 'Community Center East View',
      },
      {
        src: '/images/community_center/CC_South.jpg',
        caption: 'Community Center South View',
      },
      {
        src: '/images/community_center/CC_Amphitheatre Back_Entrance.jpg',
        caption: 'Community Center Amphitheatre Back Entrance View',
      },
    ],
  },
  {
    title: 'Parks',
    images: [
      {
        src: '/images/parks/Phase 2 Park 7.JPG',
        caption: 'Phase 2 Park 7',
      },
      {
        src: '/images/parks/park1.webp',
        caption: 'Park1',
      },
      {
        src: '/images/parks/park2.webp',
        caption: 'Park2',
      },
      {
        src: '/images/parks/park3.webp',
        caption: 'Park3',
      },
      {
        src: '/images/parks/Phase 1 Park 1 1.jpeg',
        caption: 'Phase 1 Park 1 1',
      },
      {
        src: '/images/parks/Phase 1 Park 1 2.jpeg',
        caption: 'Phase 1 Park 1 2',
      },
      {
        src: '/images/parks/Phase 1 Park 1 Gazebo.jpeg',
        caption: 'Phase 1 Park 1 Gazebo',
      },
      {
        src: '/images/parks/Phase 1 Park 3 2.jpeg',
        caption: 'Phase 1 Park 3 2',
      },
      {
        src: '/images/parks/Phase 1 Park 3 maintenance 1.jpeg',
        caption: 'Phase 1 Park 3 maintenance 1',
      },
      {
        src: '/images/parks/Phase 1 Park 3 maintenance 2.jpeg',
        caption: 'Phase 1 Park 3 maintenance 2',
      },
      {
        src: '/images/parks/Phase 1 Park 3 maintenance 3.jpeg',
        caption: 'Phase 1 Park 3 maintenance 3',
      },
      {
        src: '/images/parks/Phase 4 - Central Park 1.jpeg',
        caption: 'Phase 4 Central Park 1',
      },
      {
        src: '/images/parks/Phase 4 - Central Park 2.jpeg',
        caption: 'Phase 4 Central Park 2',
      },
      {
        src: '/images/parks/Phase 4 - Central Park 3.jpeg',
        caption: 'Phase 4 Central Park 3',
      },
      {
        src: '/images/parks/Phase 4 - Central Park 4.jpeg',
        caption: 'Phase 4 Central Park 4',
      },
      {
        src: '/images/parks/Phase 3 - Park 11 Gym 1.jpeg',
        caption: 'Phase 3   Park 11 Gym 1',
      },
      {
        src: '/images/parks/Phase 3 - Park 12 Gazebo 2.jpeg',
        caption: 'Phase 3   Park 12 Gazebo 2',
      },
      {
        src: '/images/parks/Phase 3 - Park 12 Gazebo.jpeg',
        caption: 'Phase 3   Park 12 Gazebo',
      },
      {
        src: '/images/parks/Phase 4 - Gazebo Central Park 1.jpeg',
        caption: 'Phase 4   Gazebo Central Park 1',
      },
      {
        src: '/images/parks/Phase 4 - Gazebo Central Park 2.jpeg',
        caption: 'Phase 4   Gazebo Central Park 2',
      },
      {
        src: '/images/parks/Phase 4 - Park 1 - Accupressure 1.jpeg',
        caption: 'Phase 4   Park 1   Accupressure 1',
      },
      {
        src: '/images/parks/Phase 4 - Park 1 - Accupressure 2.jpeg',
        caption: 'Phase 4   Park 1   Accupressure 2',
      },

      {
        src: '/images/parks/image1.webp',
        caption: 'Central Park 1',
      },
      {
        src: '/images/parks/image5.webp',
        caption: 'Central Park 2',
      },
      {
        src: '/images/parks/image6.webp',
        caption: 'Central Park 3',
      },
      {
        src: '/images/parks/park-photo-8.jpeg',
        caption: 'Park photo 8',
      },

      {
        src: '/images/parks/park-photo-1_1.jpeg',
        caption: 'Park photo 1 1',
      },
      {
        src: '/images/parks/park-photo-2.jpeg',
        caption: 'Park photo 2',
      },

      {
        src: '/images/parks/park-photo-4.jpeg',
        caption: 'Park photo 4',
      },
      {
        src: '/images/parks/park-photo-5.jpeg',
        caption: 'Park photo 5',
      },
      {
        src: '/images/parks/park-photo-5_1.jpeg',
        caption: 'Park photo 5 1',
      },
      {
        src: '/images/parks/park-photo-7.jpeg',
        caption: 'Park photo 7',
      },
    ],
  },
  {
    title: 'Play Areas',
    images: [
      {
        src: '/images/play/Phase 1 - Park 3 Kids Play 1.jpeg',
        caption: 'Phase 1   Park 3 Kids Play 1',
      },
      {
        src: '/images/play/Phase 1 - Park 3 Kids Play 2.jpeg',
        caption: 'Phase 1   Park 3 Kids Play 2',
      },
      {
        src: '/images/play/Phase 3 - Park 11 Kids Play 1.jpeg',
        caption: 'Phase 3   Park 11 Kids Play 1',
      },
      {
        src: '/images/play/Phase 3 - Park 11 Kids Play 2.jpeg',
        caption: 'Phase 3   Park 11 Kids Play 2',
      },
      {
        src: '/images/play/Phase 3 - Park 11 Kids Play 3.jpeg',
        caption: 'Phase 3   Park 11 Kids Play 3',
      },
      {
        src: '/images/play/Phase 3 - Park 12 Kids Play 1.jpeg',
        caption: 'Phase 3   Park 12 Kids Play 1',
      },
      {
        src: '/images/play/Phase 3 - Park 12 Kids Play 2.jpeg',
        caption: 'Phase 3   Park 12 Kids Play 2',
      },
      {
        src: '/images/play/Phase 4 - Kids Play Area 2.jpeg',
        caption: 'Phase 4   Kids Play Area 2',
      },
      {
        src: '/images/play/Phase 4 - Kids Play Area 3.jpeg',
        caption: 'Phase 4   Kids Play Area 3',
      },
      {
        src: '/images/play/Phase 4 - Kids Play Area.jpeg',
        caption: 'Phase 4   Kids Play Area',
      },
    ],
  },
  {
    title: 'Solar Energy',
    images: [
      {
        src: '/images/solar/Phase 1 - Park Solar 1.jpeg',
        caption: 'Phase 1 Park Solar 1',
      },
      {
        src: '/images/solar/Phase 1 - Park Solar 2.JPG',
        caption: 'Phase 1 Park Solar 2',
      },
      {
        src: '/images/solar/Phase 1 - Park Solar 3.jpeg',
        caption: 'Phase 1 Park Solar 3',
      },
      {
        src: '/images/solar/Phase 1 - Park Solar 4.jpeg',
        caption: 'Phase 1 Park Solar 4',
      },
      {
        src: '/images/solar/Phase 1 - Social infra - 1.jpeg',
        caption: 'Phase 1 Social infra 1',
      },
      {
        src: '/images/solar/Phase 1 - Social infra - 2.JPG',
        caption: 'Phase 1 Social infra 2',
      },
    ],
  },
];
